import React from 'react';
import SvgIcon from './SvgIcon';

const AlertsEmpty = props => {
    return (
        <SvgIcon {...props}>
            <g fill="none" fillRule="evenodd">
                <path
                    d="M18.956 42.732c-36.14 43.123-11.575 103.797 0 124.513 11.574 20.715 38.573 22.513 73.682 0s16.77-45.203 40.155-68.643c23.386-23.439 66.492-29.586 66.492-54.337 0-24.751-36.807-33.79-66.492-34.483C103.108 9.089 55.095-.39 18.956 42.732z"
                    fill="#EEF6FF"
                />
                <g transform="translate(11.494 .46)">
                    <g fillRule="nonzero">
                        <path
                            d="M130.268 0H45.977C35.402.013 26.833 8.582 26.82 19.157v137.931c.013 10.575 8.582 19.145 19.157 19.157 0 0 59.222-.088 87.927-.157 8.43-.034 15.25-6.869 15.265-15.299l.256-141.632C149.413 8.582 140.843.013 130.268 0z"
                            fill="#8DB0D6"
                        />
                        <path
                            d="M137.931 149.425H38.314a3.831 3.831 0 01-3.831-3.831V22.989a3.831 3.831 0 013.831-3.832h99.617a3.831 3.831 0 013.831 3.832v122.605a3.831 3.831 0 01-3.831 3.831z"
                            fill="#EEF6FF"
                        />
                    </g>
                    <ellipse
                        fill="#3777BC"
                        fillRule="nonzero"
                        opacity=".504"
                        cx="124.306"
                        cy="138.866"
                        rx="2.139"
                        ry="2.132"
                    />
                    <ellipse
                        fill="#3777BC"
                        fillRule="nonzero"
                        opacity=".28"
                        cx="101.104"
                        cy="37.722"
                        rx="4.102"
                        ry="4.089"
                    />
                    <ellipse fill="#3777BC" fillRule="nonzero" cx="124.652" cy="64.737" rx="1.339" ry="1.335" />
                    <ellipse fill="#3777BC" fillRule="nonzero" cx="48.976" cy="108.231" rx="2.523" ry="2.515" />
                    <g transform="translate(161.233 17.526)" stroke="#3777BC" strokeWidth=".797">
                        <path d="M3.741 11.635L8.757 3.13l3.67 6.267H2.393L6.137 3.13l4.942 8.505z" />
                        <ellipse cx="7.41" cy="7.382" rx="7.41" ry="7.382" />
                    </g>
                    <g transform="translate(7.586 41.632)" stroke="#3777BC" strokeWidth=".717">
                        <path d="M3.09 9.611l4.143-7.025 3.031 5.176H1.977l3.092-5.176 4.083 7.025z" />
                        <ellipse cx="6.121" cy="6.098" rx="6.121" ry="6.098" />
                    </g>
                    <g transform="translate(.603 128.713)" stroke="#3777BC" strokeWidth=".598">
                        <path d="M2.999 9.326l4.02-6.817L9.96 7.533H1.918l3-5.024L8.88 9.326z" />
                        <ellipse cx="5.94" cy="5.918" rx="5.94" ry="5.918" />
                    </g>
                    <ellipse fill="#D8D8D8" fillRule="nonzero" cx="164.799" cy="97.965" rx="1.339" ry="1.335" />
                    <g transform="translate(45.9 64.23)" fillRule="nonzero">
                        <path
                            d="M14.276 0C6.392 0 0 6.392 0 14.276c0 7.884 6.392 14.276 14.276 14.276 7.884 0 14.276-6.392 14.276-14.276C28.552 6.392 22.16 0 14.276 0z"
                            fill="#3777BC"
                        />
                        <path
                            d="M15.517 15.517h-2.483a3.103 3.103 0 00-3.103 3.104c0 .342.28.62.625.62h7.44a.625.625 0 00.625-.62 3.103 3.103 0 00-3.104-3.104z"
                            fill="#FFF"
                        />
                        <circle fill="#FFF" cx="14.276" cy="11.793" r="2.483" />
                    </g>
                    <g transform="translate(101.762 95.264)" fillRule="nonzero">
                        <path
                            d="M14.276 0C6.392 0 0 6.392 0 14.276c0 7.884 6.392 14.276 14.276 14.276 7.884 0 14.276-6.392 14.276-14.276C28.552 6.392 22.16 0 14.276 0z"
                            fill="#3777BC"
                        />
                        <path
                            d="M15.517 15.517h-2.483a3.103 3.103 0 00-3.103 3.104c0 .342.28.62.625.62h7.44a.625.625 0 00.625-.62 3.103 3.103 0 00-3.104-3.104z"
                            fill="#FFF"
                        />
                        <circle fill="#FFF" cx="14.276" cy="11.793" r="2.483" />
                    </g>
                    <g fillRule="nonzero">
                        <path
                            d="M114.176 90.575c0-7.226-7.115-13.104-15.862-13.104-8.746 0-15.862 5.878-15.862 13.104 0 7.225 7.116 13.103 15.862 13.103a19.01 19.01 0 004.202-.473l7.956 3.183a.691.691 0 00.942-.717l-.763-6.862c2.276-2.326 3.525-5.238 3.525-8.234z"
                            fill="#A4C3E4"
                        />
                        <path
                            d="M103.831 88.506H92.797a.69.69 0 110-1.38h11.034a.69.69 0 110 1.38zm-4.138 5.517h-6.896a.69.69 0 110-1.38h6.896a.69.69 0 110 1.38z"
                            fill="#FFF"
                        />
                    </g>
                    <g fillRule="nonzero">
                        <path
                            d="M62.452 59.54c0-7.225 7.116-13.103 15.862-13.103 8.747 0 15.862 5.878 15.862 13.103s-7.115 13.104-15.862 13.104c-1.405 0-2.818-.16-4.202-.474l-7.956 3.183a.691.691 0 01-.941-.716l.763-6.863c-2.277-2.326-3.526-5.237-3.526-8.234z"
                            fill="#A4C3E4"
                        />
                        <path
                            d="M72.797 57.471H83.83a.69.69 0 100-1.379H72.797a.69.69 0 100 1.38zm0 5.518h6.896a.69.69 0 100-1.38h-6.896a.69.69 0 100 1.38z"
                            fill="#FFF"
                        />
                    </g>
                </g>
                <circle fill="#A4C3E4" fillRule="nonzero" cx="99.617" cy="163.218" r="7.663" />
            </g>
        </SvgIcon>
    );
};

AlertsEmpty.displayName = 'AlertsEmptyIcon';

export default AlertsEmpty;
